/* eslint-disable eslint-comments/disable-enable-pair -- needed */
/* eslint-disable no-unsafe-optional-chaining -- needed */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { Selectors } from '@americanexpress/axp-benefits-utils';
import { getProductRegistryById, getSelectedProduct } from '@americanexpress/product-ducks';
import QuickView from '../new/detail/components/QuickView';
import normalize from '../new/view-all/components/card-benefits-tile/utils/normalize';
import { ctaProtocolCheck } from '../new/view-all/components/card-benefits-tile/utils';

function QuickViewWrapper(properties) {
  const parameters = properties?.params || {};
  const cardNameState = properties?.cardNameState;
  const cardNameParams = parameters?.cardname;
  const getCardNameFromState = cardNameState?.data?.cardDetails?.cardName;
  const cardNameValueToUse = getCardNameFromState || cardNameParams;
  const benefitNamesList = properties?.benefitNamesList;
  const benefitsData = properties?.benefitsData;
  const name = properties?.name;

  const [benefitNamesIndex, setBenefitNamesIndex] = useState(benefitNamesList?.indexOf(name.name));
  const [currentBenefit, setCurrentBenefit] = useState(name?.name);
  const [title, setTitle] = useState(properties?.title);
  const [detailPage, setDetailPage] = useState(properties?.detailPage);
  const [detailRequiresLogin, setDetailRequiresLogin] = useState(properties?.detailRequiresLogin);
  const [showStatus, setShowStatus] = useState(properties?.showStatus);
  const [statusLabel, setStatusLabel] = useState(properties?.statusLabel);
  const [enrollmentApplicationStatus, setEnrollmentApplicationStatus] = useState(properties?.enrollmentApplicationStatus);
  const [copy, setCopy] = useState(properties?.copy);
  const [showEnroll, setShowEnroll] = useState(properties?.showEnroll);
  const [enrollLabel, setEnrollLabel] = useState(properties?.enrollLabel);
  const [enrollHref, setEnrollHref] = useState(properties?.enrollHref);
  const [showExternal, setShowExternal] = useState(properties?.showExternal);
  const [externalLabel, setExternalLabel] = useState(properties?.externalLabel);
  const [externalHref, setExternalHref] = useState(properties?.externalHref);
  const [benefitForAccordian, setBenefitForAccordian] = useState(benefitsData && benefitsData[name]);
  const [catCTA, setcatCTA] = useState();
  const [rejectedmessage, setRejectedMessage] = useState();
  const [resyModuleProps, setResyModuleProps] = useState();
  // Quick View props
  const toggleModal = properties?.toggleModal;
  const closeButtonLabel = properties?.closeButtonLabel;
  const dismissible = properties?.dismissible;
  const closeButtonProps = properties?.closeButtonProps;
  const modalDialogRef = properties?.modalDialogRef;
  const cardname = properties?.cardname;

  let nextTitle;
  let prevTitle;
  if (benefitNamesIndex + 1 < benefitNamesList?.length) {
    nextTitle = benefitsData && benefitsData[benefitNamesList[benefitNamesIndex + 1]]?.benefitTitle;
  } else {
    nextTitle = benefitsData && benefitsData[benefitNamesList[0]]?.benefitTitle;
  }
  if (benefitNamesIndex - 1 >= 0) {
    prevTitle = benefitsData && benefitsData[benefitNamesList[benefitNamesIndex - 1]]?.benefitTitle;
  } else {
    prevTitle = benefitsData && benefitsData[benefitNamesList[benefitNamesList?.length - 1]]?.benefitTitle;
  }

  const handleTitle = (index) => {
    setTitle(benefitsData && benefitsData[benefitNamesList[index]]?.benefitTitle);
  };

  const handleNext = async () => {
    let newIndex = benefitNamesIndex;
    do {
      newIndex = (newIndex + 1) % benefitNamesList.length;
      const key = benefitNamesList[newIndex];
      const hasValue = key && benefitsData[key] !== undefined;
      if (hasValue) break;
    } while (newIndex !== benefitNamesIndex);
    setBenefitNamesIndex(newIndex);
  };

  const handlePrevious = async () => {
    let newIndex = benefitNamesIndex;
    do {
      newIndex = (newIndex - 1 + benefitNamesList.length) % benefitNamesList.length;
      const key = benefitNamesList[newIndex];
      const hasValue = key && benefitsData[key] !== undefined;
      if (hasValue) break;
    } while (newIndex !== benefitNamesIndex);
    setBenefitNamesIndex(newIndex);
  };

  useEffect(() => {
    // Applying no background scrolling on mount
    document.body.style.overflow = 'hidden';
    // Revert background scrolling on unmount
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  useEffect(() => {
    setCurrentBenefit(benefitNamesList && benefitNamesList[benefitNamesIndex]);
  }, [benefitNamesIndex]);

  useEffect(() => {
    handleTitle(benefitNamesIndex);
  }, [title]);

  useEffect(() => {
    const normalizedBenefit = normalize(benefitsData && benefitsData[currentBenefit]);
    setDetailPage(window.location.origin + normalizedBenefit?.summary?.learnMoreCTA?.link + properties.productSelected);
    setDetailRequiresLogin(normalizedBenefit?.detailRequiresLogin);
    setTitle(normalizedBenefit?.title);
    setShowStatus(normalizedBenefit?.detail?.status?.enabled);
    setStatusLabel(normalizedBenefit?.detail?.status?.label);
    setEnrollmentApplicationStatus(normalizedBenefit?.summary?.status?.enrollmentApplication.status);
    setCopy(normalizedBenefit?.detail?.copy);
    setShowEnroll(normalizedBenefit?.detail?.enrollCTA.enabled);
    setEnrollLabel(normalizedBenefit?.detail?.enrollCTA.label);
    setEnrollHref(normalizedBenefit?.detail?.enrollCTA.link);
    setShowExternal(normalizedBenefit?.detail?.externalCTA?.enabled);
    setExternalLabel(normalizedBenefit?.detail?.externalCTA.label);
    setExternalHref(ctaProtocolCheck(normalizedBenefit?.detail?.externalCTA?.link));
    setBenefitForAccordian(normalizedBenefit);
    setRejectedMessage(normalizedBenefit?.detail?.status?.enrollmentApplication?.rejectedMessage);
    const ctas = [
      normalizedBenefit?.detail?.enrollCTA,
      normalizedBenefit?.detail?.externalCTA,
      normalizedBenefit?.detail?.learnMoreCTA,
    ];
    const enabledCTAs = ctas.filter((cta) => cta?.enabled);
    setcatCTA(enabledCTAs?.[0]);
    const moduleProps = {
      benefitTitle: normalizedBenefit?.title,
      details: normalizedBenefit?.detail,
      disclosures: normalizedBenefit?.disclosures,
    };
    setResyModuleProps(moduleProps);
  }, [currentBenefit]);

  return (
    <QuickView
      toggleModal={toggleModal}
      closeButtonLabel={closeButtonLabel}
      dismissible={dismissible}
      closeButtonProps={closeButtonProps}
      modalDialogRef={modalDialogRef}
      {...properties}
      cardNameValueToUse={cardNameValueToUse}
      cardname={cardname}
      name={name}
      title={title}
      copy={copy}
      showStatus={showStatus}
      catCTA={catCTA}
      statusLabel={statusLabel}
      enrollmentApplicationStatus={enrollmentApplicationStatus}
      showEnroll={showEnroll}
      enrollLabel={enrollLabel}
      enrollHref={enrollHref}
      showExternal={showExternal}
      externalLabel={externalLabel}
      externalHref={externalHref}
      detailPage={detailPage}
      detailRequiresLogin={detailRequiresLogin}
      handleNext={handleNext}
      handlePrevious={handlePrevious}
      typeOfTerms={benefitForAccordian}
      sorBenefitId={benefitsData && benefitsData[benefitNamesList[benefitNamesIndex]]?.sorBenefitId}
      benefitName={benefitsData && benefitsData[benefitNamesList[benefitNamesIndex]]?.benefitName}
      benefitNamesIndex={benefitNamesIndex}
      nextTitle={nextTitle}
      prevTitle={prevTitle}
      rejectedmessage={rejectedmessage}
      resyModuleProps={resyModuleProps}
    />
  );
}

export function mapStateToProps(state) {
  const product = getSelectedProduct(state);
  return {
    cardNameState: Selectors.getCardNameFromState(state),
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
    env: fromJS(state).getIn(['config', 'localeFilename']),
    login: Boolean(getSelectedProduct(state)),
    productType: getProductRegistryById(state, product)?.type,
    accountToken: getSelectedProduct(state),
  };
}

export const ComponentUnderTest = QuickViewWrapper;
export default connect(mapStateToProps, null)(QuickViewWrapper);
